// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable max-len */

import { addErrorToReport, updateLocale } from '@americanexpress/one-app-ducks';
import { loadProducts } from 'axp-product-ducks';
import {
  loadLocation,
  resetMerchant,
} from '@americanexpress/one-maps-base';
import { queryProcedureResult } from 'iguazu-rpc';

const mapDispatchToProps = (dispatch) => ({
  loadProducts: () => dispatch(loadProducts()),
  updateLocale: (locale) => dispatch(updateLocale(locale)),
  resetMerchant: () => dispatch(resetMerchant()),
  loadLocation: (args) => dispatch(loadLocation(args)),
  createActionCaptureBDaaS: (args) => dispatch(queryProcedureResult({ procedureName: 'createActionCapture', args })),
  createMerchantMapLogImpression: (args) => dispatch(queryProcedureResult({ procedureName: 'CreateMerchantMapLogImpression', args })),
  updateOfferEnrollment: (args) => dispatch(queryProcedureResult({ procedureName: 'updateOfferEnrollment', args })),
  createMerchantMapOffersEnrollment: (args) => dispatch(queryProcedureResult({ procedureName: 'CreateMerchantMapOffersEnrollment', args })),
  updateMerchantSuggestion: (args) => dispatch(queryProcedureResult({ procedureName: 'updateMerchant', args })),
  createMerchantEditSuggestion: (args) => dispatch(queryProcedureResult({ procedureName: 'CreateMerchantEditSuggestion', args })),
  readIndustryBonusBDaaS: (args) => dispatch(queryProcedureResult({ procedureName: 'loadIndustryBonus', args })),
  readIndustryBonusOneData: (args) => dispatch(queryProcedureResult({ procedureName: 'ReadMerchantMapIndustryBonusCategories', args })),
  readOffersMapsBDaaS: (args) => dispatch(queryProcedureResult({ procedureName: 'loadOffersMaps', args })),
  readOffersBDaaS: (args) => dispatch(queryProcedureResult({ procedureName: 'loadOffers', args })),
  readEnrolledOffersBDaaS: (args) => dispatch(queryProcedureResult({ procedureName: 'loadEnrolledOffers', args })),
  readOffersOneData: (args) => dispatch(queryProcedureResult({ procedureName: 'ReadMerchantMapOffers', args })),
  readEnrolledOffersOneData: (args) => dispatch(queryProcedureResult({ procedureName: 'ReadMerchantMapEnrolledOffers', args })),
  readOffersMapsOneData: (args) => dispatch(queryProcedureResult({ procedureName: 'ReadMerchantMapsTabOffers', args })),
  readMerchantsBDaaS: (args) => dispatch(queryProcedureResult({ procedureName: 'loadMerchants', args })),
  readMerchantsOneData: (args) => dispatch(queryProcedureResult({ procedureName: 'ReadMerchantMapRecommendation', args })),
  readMerchantsPublicOneData: (args) => dispatch(queryProcedureResult({ procedureName: 'ReadMerchantPublicMapRecommendation', args })),
  readKeywords: (args) => dispatch(queryProcedureResult({ procedureName: 'loadKeywords', args })),
  readMerchantPersonalizationTypeahead: (args) => dispatch(queryProcedureResult({ procedureName: 'ReadMerchantPersonalizationTypeahead', args })),
  readProgramDetails: (args) => dispatch(queryProcedureResult({ procedureName: 'loadProgramDetails', args })),
  readFilterlabels: (args) => dispatch(queryProcedureResult({ procedureName: 'loadFilterlabels', args })),
  readInterstitial: (args) => dispatch(queryProcedureResult({ procedureName: 'loadInterstitial', args })),
  readNotification: (args) => dispatch(queryProcedureResult({ procedureName: 'loadNotification', args })),
  addError: (error, otherData) => dispatch(addErrorToReport(error, otherData)),

});

export default mapDispatchToProps;
